import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "d-flex align-center justify-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_NurserySchoolDiaryContainer = _resolveComponent("NurserySchoolDiaryContainer")!
  const _component_NurseryHoursDiaryContainer = _resolveComponent("NurseryHoursDiaryContainer")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.activeDiary)
      ? (_openBlock(), _createBlock(_component_v_list, { key: 0 }, {
          default: _withCtx(() => [
            (_ctx.shouldShowNurserySchoolDiary)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:activeDiary', 'nursery')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('others.nurseryDiary')), 1),
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("mdi-chevron-right", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider),
            (_ctx.shouldShowNurseryHoursDiary)
              ? (_openBlock(), _createBlock(_component_v_list_item, {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:activeDiary', 'nursery-hours')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('others.extendedCareDiary')), 1),
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("mdi-chevron-right", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_divider)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.activeDiary === 'nursery')
      ? (_openBlock(), _createBlock(_component_NurserySchoolDiaryContainer, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.activeDiary === 'nursery-hours')
      ? (_openBlock(), _createBlock(_component_NurseryHoursDiaryContainer, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}